/**
 * 描述：选择租户服务
 * 日期：2023-2-22
 * 作者：bai.zhiming
 */
"use strict";
angular.module("selectiveOrganizationServiceModule", [])
    .factory("selectiveOrganization", ["httpService", "$state", "$modal", "$q", 'modalDialog', function(httpService, $state, $modal, $q, modalDialog) {
        return {
            selecteOg: function(groups) {
                var deffer = $q.defer();
                var selectParams = {
                    param: groups,
                };
                var MOBILEPHONE_REGEXP = /^(1[2-9][0-9])\d{8}$/;
                var EMAIL_REGEXP = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
                if(MOBILEPHONE_REGEXP.test(groups)) {
                    selectParams.name = 'mobile';
                } else if(EMAIL_REGEXP.test(groups)) {
                    selectParams.name = 'email';
                } else {
                    selectParams.name = 'userName';
                }
                httpService.http("/mcnww/web/user/existsTenant.do", selectParams, "post", true, true).then((data) => {
                    if(data.data) {
                        if(data.data.length === 1) {
                            localStorage.setItem('loginUser', JSON.stringify(data.data[0]));
                            deffer.resolve(data.data[0].tenantId);
                        } else if(data.data.length > 1){
                            var modalInstance = $modal.open({
                                templateUrl: "./login/selectiveOrganization/index.html",
                                windowClass: 'selective-organization',
                                backdrop: false,
                                controller: "selectiveOrganizationCtrl",
                                resolve: {
                                    groups: function() {
                                        return data.data;
                                    },
                                }
                            });
                            modalInstance.result.then(function(result) {
                                localStorage.setItem('loginUser', JSON.stringify({tenantId: result}))
                                deffer.resolve(result);
                            });
                        }else {
                            modalDialog.success(data.message, "success", false, function() {}, function() {}, '', 'leftLogin');
                            deffer.reject();
                        }
                    } else {
                        modalDialog.success(data.message, "success", false, function() {}, function() {}, '', 'leftLogin login-forget-password');
                        deffer.reject();
                    }
                });
                return deffer.promise;
            }
        };
    }]);